export const INACTIVE_THRESHOLD_MS = 3 * 24 * 60 * 60 * 1000;

/** 3+ gündür aktif olmayan öğrenci mi? (last_active_at hiç yoksa da pasif sayılır.) */
export function isInactive(lastActiveAt: string | null | undefined): boolean {
  if (!lastActiveAt) return true;
  return Date.now() - new Date(lastActiveAt).getTime() > INACTIVE_THRESHOLD_MS;
}
